import { App as AntdApp, ConfigProvider } from 'antd';
import type { FC, PropsWithChildren } from 'react';
import { appTheme, formConfig } from '@/config';
import { NotificationBinder } from './notification-binder';

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <ConfigProvider theme={appTheme} componentSize='middle' form={formConfig}>
    <AntdApp>
      <NotificationBinder />
      {children}
    </AntdApp>
  </ConfigProvider>
);
